import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, RADIOLOGY_DETAILS_PATH, RADIOLOGY_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const RadiologySummaryPage = lazy(() => import('./pages/RadiologySummaryPage'));
const RadiologyDetailPage = lazy(() => import('./pages/RadiologyDetailPage'));

export const RADIOLOGY_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <RadiologySummaryPage />,
    displayTitle: () => 'Radiology Reports',
    pageType: PageType.PRIVATE,
    path: RADIOLOGY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.radiologyReports,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <RadiologyDetailPage />,
    displayTitle: () => 'Radiology Report Details',
    pageType: PageType.PRIVATE,
    path: RADIOLOGY_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.radiologyReports,
  },
];
